export const levelLabelMap = {
  1: '入門クラス',
  2: '初級クラス',
  3: '中級クラス',
  4: '上級クラス',
}

export const genderLabelMap = {
  women: '女性専用',
  men: '男性専用',
}
